import { render, staticRenderFns } from "./qsList2.vue?vue&type=template&id=1d1a8ebc&scoped=true&"
import script from "./qsList2.vue?vue&type=script&lang=js&"
export * from "./qsList2.vue?vue&type=script&lang=js&"
import style0 from "./qsList2.vue?vue&type=style&index=0&id=1d1a8ebc&scoped=true&lang=css&"
import style1 from "./qsList2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a8ebc",
  null
  
)

export default component.exports